<template>
  <div class="case">
<!--    <div class="center" style="font-size: 2em;">-->
<!--      <h2 style="margin-top: 80px">ZHL压缩技术行业应用</h2>-->
<!--    </div>-->
    <div v-for="item in data" :key="index">

    <div class="center" style="margin-top: 120px;">
      <div class="between" style="width: 60%;margin: 5px;">
        <div style="width: 70%;text-align: left;font-size:larger;">
          <div style="font-size: 1.5em; margin: 15px;">{{ item.title }}</div>
          <div>
            {{item.content }}
          </div>


        </div>
        <div style="height: 100px;width:30%;"><img src="../assets/img/1-230109142523919.png"></div>

      </div>
    </div>
    </div>




    <div style="margin-top: 200px">
    <Footer/>
    </div>

  </div>
</template>
<script>
import Banner from "../components/Banner";
import Footer from "@/views/footer.vue";
export default {
  components: {
    Banner,
    Footer
  },
  data() {
    return {
      storedValue:0,
      id:0,
      a:1111,
      data:[],
      title:"",
      description:"",
      title2:"",
      description2:"",
      title3:"",
      description3:"",
      loading: true,
      caseList: []
    };
  },
  mounted() {


    this.id=this.$route.params.a

    console.log("输出: 参数")
    console.log(this.id); // 输出: 'value'
    // 从 sessionStorage 获取数据
    // this.storedValue = sessionStorage.getItem('id');
    // console.log("输出: 'value'")
    // console.log(this.storedValue); // 输出: 'value'

    window.console.log("case");
    this.$http
      .get("Cases/GetCasesAll")
      .then(response => {
        //console.log(response);
        this.caseList = response.data;
        //window.console.log(this.caseList);
        this.loading = false;
      })
      .catch(function(error) {
        window.console.log(error);
      });
    this.getData()
  },
  methods:{
    detail(){
// const a=this.a
      this.$router.push({
        name: 'text', // 使用路由的 name 属性
        params: { a: this.a }
      });

    },
    getData() {


      const headers = {};

      // 发送 GET 请求并在请求中添加自定义请求头
      this.$http.get(`yasubit/website/${this.id}`, { headers })
          .then(response => {
            // 请求成功时更新数据
            console.log(8888);
            this.data = response.data.data[0].archiveList;
            console.log( this.data)





          })
          .catch(error => {
            // 请求失败时处理错误
            console.error('Error fetching data:', error);
          });


    }


  }
};
</script>

 <style lang="scss" scoped>


 .between{

   display: flex;
   flex-direction: row;
   justify-content: space-between;
 }

 .center{
   display: flex;align-items: center; text-align: center;justify-content: center
 }
 .one-third{
   width: 33.333333%;
   height: 50px;
   background-color: pink;
 }
 .one-five{
   display: flex;align-items: center; text-align: center;justify-content: center;flex-direction: column;
   width: 20%;
   height: 50px;

 }



 .case {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  //background-color: #14679f;

  &-section {
    width: 100%;
    &-content {
      width: 1240px;
      min-height: 1000px;
      margin: 0 auto;
      background-color: #fff;

      &-list {
        width: 100%;
        height: 500px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid pink;

        img {
          width: 612px;
          height: 314px;
        }
        .content-list-abstract {
          width: 290px;
          height: 350px;
          padding: 0 20px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          .abstract-title {
            line-height: 30px;
            font-size: 22px;
            color: #e13834;
          }
          .abstract-content {
            height: 150px;
            color: #484848;
            font-size: 15px;

            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 7;
            -webkit-box-orient: vertical;
            white-space: normal !important;
            word-wrap: break-word;
            //border: 1px solid pink;
          }
          .more {
            display: flex;
            justify-content: flex-start;
            .text-decoration {
              text-decoration: none;

              span {
                color: #000;
              }
              img {
                width: 12px;
                height: 12px;
              }
            }
          }
        }
        .abstract-active {
          order: -1;
        }
      }
    }
  }
}
</style>